var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ticketcats',{attrs:{"categories":_vm.ticketCategories,"organisationtypes":_vm.organisationTypes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }